<ul role="menu" class="menu-utility">
  @for (item of menu.siteMenuItems; track item; let i = $index) {
    <li
      role="menuitem"
      class="menu-utility__item"
      >
      <mflooring-menu-item
        [class.item__parent]="item.childMenuItems.length"
        [class.item__parent--opened]="openedMenu === i"
        [hasChildren]="item.childMenuItems.length"
        [page]="page"
        [site]="item?.links?.site"
        [linkName]="item?.name"
        (click)="onOpenMenu(i)"
        >
        {{ item.name }}
      </mflooring-menu-item>
      @if (item.childMenuItems.length) {
        <ul
          class="menu-utility__submenu"
          role="menu"
          [class.menu-utility__submenu--opened]="openedMenu === i"
          >
          @for (subitem of item.childMenuItems; track subitem) {
            <li
              class="menu-utility__submenu__item"
              role="menuitem"
              >
              <mflooring-menu-item
                (click)="onCloseMenu()"
                [page]="page"
                [site]="subitem?.links?.site"
                [linkName]="subitem?.name"
                >
                {{ subitem.name }}
              </mflooring-menu-item>
            </li>
          }
        </ul>
      }
    </li>
  }
</ul>
